import type { PrSummary } from '../../shared/pr/api';
import { requesterProgress } from '../../shared/pr/progress';
import { useI18n } from '../i18n';
import { formatDate } from '../lib/dates';
import { StatusPill } from './StatusPill';

/** One request in a list: title, number, raised date, status and how far it has come. */
export function RequestRow({ pr }: { pr: PrSummary }) {
  const { t, lang } = useI18n();
  const { done, total } = requesterProgress(pr.status);
  const href = pr.status === 'Draft' ? `#/requests/draft/${pr.prNo}` : `#/requests/${pr.prNo}`;
  return (
    <li class="req-row">
      <div class="req-row__main">
        <a class="req-row__title" href={href}>
          {pr.title}
        </a>
        <p class="caption">
          <span class="ref" dir="ltr">
            {pr.prNo}
          </span>
          {pr.created && ` · ${t('req.raised', { date: formatDate(pr.created, lang) })}`}
          {pr.rush && ` · ${t('req.rush')}`}
        </p>
      </div>
      <StatusPill status={pr.status} own />
      <progress
        class="progress"
        max={total}
        value={done}
        aria-label={t('req.progressText', { done: String(done), total: String(total) })}
      />
    </li>
  );
}
